import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ProductSectionComponentBase } from '../../../ProductSectionComponentBase';
import { ProductSectionComponent } from '../../product-section';
import { ProductAlternatesComponent } from '../product-alternates';

@Component({
  selector: 'ideal-product-alternates-section',
  imports: [ProductSectionComponent, ProductAlternatesComponent],
  templateUrl: './product-alternates-section.component.html',
  styleUrl: './product-alternates-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[style.display]': 'hasContent() ? undefined : "none"',
  },
})
export class ProductAlternatesSectionComponent extends ProductSectionComponentBase {}
